function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
import { adopt, extend, nodeOrNew, register, wrapWithAttrCheck } from '../utils/adopter.js';
import { registerMethods } from '../utils/methods.js';
import SVGNumber from '../types/SVGNumber.js';
import Shape from './Shape.js';
import { globals } from '../utils/window.js';
import * as textable from '../modules/core/textable.js';
import { isDescriptive, writeDataToDom } from '../utils/utils.js';
var Text = /*#__PURE__*/ function(Shape) {
    "use strict";
    _inherits(Text, Shape);
    function Text(node) {
        var attrs = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : node;
        _class_call_check(this, Text);
        var _this;
        _this = _call_super(this, Text, [
            nodeOrNew('text', node),
            attrs
        ]);
        var _this_dom_leading;
        _this.dom.leading = (_this_dom_leading = _this.dom.leading) !== null && _this_dom_leading !== void 0 ? _this_dom_leading : new SVGNumber(1.3) // store leading value for rebuilding
        ;
        _this._rebuild = true // enable automatic updating of dy values
        ;
        _this._build = false // disable build mode for adding multiple lines
        ;
        return _this;
    }
    _create_class(Text, [
        {
            // Set / get leading
            key: "leading",
            value: function leading(value) {
                // act as getter
                if (value == null) {
                    return this.dom.leading;
                }
                // act as setter
                this.dom.leading = new SVGNumber(value);
                return this.rebuild();
            }
        },
        {
            // Rebuild appearance type
            key: "rebuild",
            value: function rebuild(rebuild) {
                // store new rebuild flag if given
                if (typeof rebuild === 'boolean') {
                    this._rebuild = rebuild;
                }
                // define position of all lines
                if (this._rebuild) {
                    var self = this;
                    var blankLineOffset = 0;
                    var leading = this.dom.leading;
                    this.each(function(i) {
                        if (isDescriptive(this.node)) return;
                        var fontSize = globals.window.getComputedStyle(this.node).getPropertyValue('font-size');
                        var dy = leading * new SVGNumber(fontSize);
                        if (this.dom.newLined) {
                            this.attr('x', self.attr('x'));
                            if (this.text() === '\n') {
                                blankLineOffset += dy;
                            } else {
                                this.attr('dy', i ? dy + blankLineOffset : 0);
                                blankLineOffset = 0;
                            }
                        }
                    });
                    this.fire('rebuild');
                }
                return this;
            }
        },
        {
            // overwrite method from parent to set data properly
            key: "setData",
            value: function setData(o) {
                this.dom = o;
                this.dom.leading = new SVGNumber(o.leading || 1.3);
                return this;
            }
        },
        {
            key: "writeDataToDom",
            value: function writeDataToDom1() {
                writeDataToDom(this, this.dom, {
                    leading: 1.3
                });
                return this;
            }
        },
        {
            // Set the text content
            key: "text",
            value: function text(text) {
                // act as getter
                if (text === undefined) {
                    var children = this.node.childNodes;
                    var firstLine = 0;
                    text = '';
                    for(var i = 0, len = children.length; i < len; ++i){
                        // skip textPaths - they are no lines
                        if (children[i].nodeName === 'textPath' || isDescriptive(children[i])) {
                            if (i === 0) firstLine = i + 1;
                            continue;
                        }
                        // add newline if its not the first child and newLined is set to true
                        if (i !== firstLine && children[i].nodeType !== 3 && adopt(children[i]).dom.newLined === true) {
                            text += '\n';
                        }
                        // add content of this node
                        text += children[i].textContent;
                    }
                    return text;
                }
                // remove existing content
                this.clear().build(true);
                if (typeof text === 'function') {
                    // call block
                    text.call(this, this);
                } else {
                    // store text and make sure text is not blank
                    text = (text + '').split('\n');
                    // build new lines
                    for(var j = 0, jl = text.length; j < jl; j++){
                        this.newLine(text[j]);
                    }
                }
                // disable build mode and rebuild lines
                return this.build(false).rebuild();
            }
        }
    ]);
    return Text;
}(Shape);
export { Text as default };
extend(Text, textable);
registerMethods({
    Container: {
        // Create text element
        text: wrapWithAttrCheck(function() {
            var text = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : '';
            return this.put(new Text()).text(text);
        }),
        // Create plain text element
        plain: wrapWithAttrCheck(function() {
            var text = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : '';
            return this.put(new Text()).plain(text);
        })
    }
});
register(Text, 'Text');
